import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import "./index.css";
import App from "./app/index.tsx";
import * as Sentry from "@sentry/react";
import { PostHogProvider } from 'posthog-js/react'
import posthog from 'posthog-js';

posthog.init(
  import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  {
    api_host: "https://us.i.posthog.com",
    capture_pageview: false,
  }
);

// Extend Window interface to include posthog property
declare global {
  interface Window {
    posthog: typeof posthog;
  }
}

window.posthog = posthog;

Sentry.init({
  dsn: "https://908e2535400043271ca766425a8b488d@o4509338492403712.ingest.us.sentry.io/4509338502823936",
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({ maskAllText: false })
  ],
  replaysSessionSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
  replaysOnErrorSampleRate: 1.0 
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </StrictMode>,
)
